/**
 * Merkliste: alle mit dem Herz vorgemerkten Rezepte.
 */
import { useEffect, useRef } from 'react';
import { RecipeBrowser } from '../components/RecipeBrowser.tsx';
import { useRecipeFilter } from '../state/filterParams.ts';
import { texts } from '../texts/de.ts';

/** Seite der Merkliste. */
export function FavoritesPage() {
  const { filter, setFilter } = useRecipeFilter();

  // Beim Öffnen der Seite wird der Merklisten-Filter einmal gesetzt. Danach
  // darf man ihn entfernen, ohne dass er sofort wiederkommt.
  const applied = useRef(false);
  useEffect(() => {
    if (applied.current) {
      return;
    }
    applied.current = true;
    if (!filter.favoritesOnly) {
      setFilter({ ...filter, favoritesOnly: true });
    }
  }, [filter, setFilter]);

  return <RecipeBrowser mode="favorites" title={texts.favorites.title} subtitle={texts.favorites.subtitle} />;
}
